const Help = () => {

    return (
        <h1>Помощь</h1>
    )
}

export default Help